// extracted by mini-css-extract-plugin
export default {"title":"WhatsNextCard_title__p0APF","listTitle":"WhatsNextCard_listTitle__VRFzj"};